// extracted by mini-css-extract-plugin
export default {"base":"styles_base_PzwUC","view":"styles_view_cq6yV","alertContainer":"styles_alert-container_LKpZR"};